import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Dialog, Illustration, toast } from '@node-space/ui-components'
import { DurationInMilliseconds } from 'constants/General'
import { useDeleteTeamMemberMutation } from 'hooks/mutations/useDeleteTeamMemberMutation'
import { AccountUser } from 'types/accounts'

interface TeamMemberDeleteProps {
  onDeleteCallback: () => void
  userToDelete: AccountUser
  handleCloseModal: () => void
}

export const TeamMemberDelete = ({
  userToDelete,
  onDeleteCallback,
  handleCloseModal,
}: TeamMemberDeleteProps) => {
  const { t } = useTranslation()

  const { mutate: mutateDeleteTeamMember, isPending: isLoading } = useDeleteTeamMemberMutation()

  const handleOnDelete = async () => {
    mutateDeleteTeamMember(userToDelete?.id, {
      onSuccess: () => {
        onDeleteCallback()
        toast({
          header: t('teamMember.deleteSuccess', {
            userToDelete: userToDelete?.name || userToDelete?.emailAddress,
          }),
          variant: 'info',
          duration: DurationInMilliseconds.TEN_SECONDS,
        })
        handleCloseModal()
      },
      onError: () => {
        toast({
          header: t('oopsSomethingWentWrong'),
          variant: 'error',
          duration: DurationInMilliseconds.TEN_SECONDS,
        })
        handleCloseModal()
      },
    })
  }

  return (
    <Dialog
      title={`${t('deleteTeamMember')} ${userToDelete?.name || userToDelete?.emailAddress}?`}
      open
      onClose={handleCloseModal}
      Illustration={<Illustration name="CloudLightning" />}
      ActionButtons={[
        <Button
          key="deleteKey"
          testId="delete-button"
          variant="destructive"
          loading={isLoading}
          onClick={handleOnDelete}
        >
          {t('delete')}
        </Button>,
        <Button key="cancel" onClick={handleCloseModal} variant="secondary" testId="close-button">
          {t('cancel')}
        </Button>,
      ]}
    >
      <p className="text-foreground-prominent text-body-regular text-center">
        {t('deleteDescription')}
      </p>
    </Dialog>
  )
}
